import { render, staticRenderFns } from "./VariantSifterV2gTrack.vue?vue&type=template&id=3c78eab8&scoped=true&"
import script from "./VariantSifterV2gTrack.vue?vue&type=script&lang=js&"
export * from "./VariantSifterV2gTrack.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterV2gTrack.vue?vue&type=style&index=0&id=3c78eab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c78eab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c78eab8')) {
      api.createRecord('3c78eab8', component.options)
    } else {
      api.reload('3c78eab8', component.options)
    }
    module.hot.accept("./VariantSifterV2gTrack.vue?vue&type=template&id=3c78eab8&scoped=true&", function () {
      api.rerender('3c78eab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterV2gTrack.vue"
export default component.exports